import { ClientResources } from "@app/api2/api";
import { translationClient } from "@app/api2/Clients";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import BPUnexpectedError from "../Common/BPUnexpectedError";
import { B } from "react-querybuilder/dist/index-JBfP2YhA";
import { setLocale } from "yup";

export interface LocalizationContextType {
    translations: ClientResources | null;
    currentLocale: string;
    refresh: () => Promise<any>;
    setLocaleAndReload: (locale: string) => void;
}

export const TranslationContext2 = React.createContext<LocalizationContextType>({
    translations: null,
    currentLocale: "en-US",
    refresh: () => Promise.resolve(),
    setLocaleAndReload: () => Promise.resolve(),
});

// export const TranslationContext2 = React.createContext<ClientResources>(window.translation);

export const TranslationProvider2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    //   const translation = window.translation;
    const cookieName = ".AspNetCore.Culture";

    const getCurrentLocaleFromCookie = (): string => {
        const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        // console.log("Locale from cookie:", match ? match[2].split('|')[0].split('=')[1] : null);
        return match ? match[2].split('|')[0].split('=')[1] : null;
    };

    const [currentLocale, setCurrentLocale] = React.useState(getCurrentLocaleFromCookie());

    const query = useQuery({
        queryKey: ['translations'],
        queryFn: async () => {
            const cacheTimestamp = localStorage.getItem("translation_timestamp");
            const currentTimestamp = document.body.getAttribute("data-translation-timestamp");
            // console.log("translation cache timestamp", cacheTimestamp, "current timestamp", currentTimestamp);
            if (cacheTimestamp !== currentTimestamp) {

                const locale = await translationClient.getLocale();
                const translations = await translationClient.getTranslation(locale.localeName);

                localStorage.setItem("locale", locale.localeName);
                localStorage.setItem("translation", JSON.stringify(translations));
                localStorage.setItem("translation_timestamp", currentTimestamp);

                return translations;
            } else {
                const translationSerialized = localStorage.getItem("translation");
                const locale = localStorage.getItem("locale");
                const translations = (JSON.parse(translationSerialized) as ClientResources);
                return translations;
            }
        },
        // onSuccess: (data) => {
        //     console.log("Loaded yup translations for locale:", currentLocale);
        //     setLocale(data.yup);
        // }
    });

    React.useEffect(() => {
        if (query.data) {
            console.log("Loaded yup translations for locale:", currentLocale);
            setLocale(query.data.yup);
        }
    }, [query.data])


    const setLocaleAndReload = (locale: string) => {
        setCurrentLocale(locale);

        localStorage.removeItem("translation");
        localStorage.removeItem("translation_timestamp");

        if (locale) {
            document.cookie = cookieName + "=c=" + locale + "|uic=" + locale + "; path=/; max-age=2630000";
        } else {
            document.cookie = cookieName + "=; path=/; max-age=-999999";
        }

        window.location.reload();
    };

    if (query.isLoading) {
        return null; // Or a loading spinner
    }
    if (query.isError) {
        return <BPUnexpectedError />;
    }

    return (
        <TranslationContext2.Provider value={{ currentLocale: currentLocale, translations: query.data ?? null, refresh: query.refetch, setLocaleAndReload: setLocaleAndReload }}>
            {children}
        </TranslationContext2.Provider>
    );
};

// Custom hook to use the TranslationContext
export const useTranslation2 = () => React.useContext(TranslationContext2);
